import * as fromDatatype from '../datatype-library/index';

export interface bl_applet_template_message_placeholder_hdr_RowInterface {
guid: fromDatatype.GuidDataFieldInterface;
namespace: fromDatatype.VarcharDatatypeInterface;
applet_guid: fromDatatype.GuidDataFieldInterface;
module_guid: fromDatatype.GuidDataFieldInterface;
template_message_hdr_guid: fromDatatype.GuidDataFieldInterface;
placeholder_name: fromDatatype.VarcharDatatypeInterface;
placeholder_code: fromDatatype.VarcharDatatypeInterface;
placeholder_type: fromDatatype.VarcharDatatypeInterface;
placeholder_source: fromDatatype.VarcharDatatypeInterface;
default_value: fromDatatype.VarcharDatatypeInterface;
template_message_line_guid: fromDatatype.GuidDataFieldInterface;
placeholder_data_type: fromDatatype.VarcharDatatypeInterface;
value_string: fromDatatype.VarcharDatatypeInterface;
value_file: fromDatatype.VarcharDatatypeInterface;
value_numeric: fromDatatype.NumericDatatypeInterface;
value_datetime: fromDatatype.TimestampTzDatatypeInterface;
value_json: fromDatatype.JsonDatatypeInterface;
index: fromDatatype.IntegerDatatypeInterface;
description: fromDatatype.TextDatatypeInterface;
acl_config: fromDatatype.JsonDatatypeInterface;
acl_policy: fromDatatype.JsonDatatypeInterface;
property_json: fromDatatype.JsonDatatypeInterface;
created_date: fromDatatype.TimestampTzDatatypeInterface;
updated_date: fromDatatype.TimestampTzDatatypeInterface;
created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
status: fromDatatype.VarcharDatatypeInterface;
revision: fromDatatype.GuidDataFieldInterface;
vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_applet_template_message_placeholder_hdr_RowClass implements bl_applet_template_message_placeholder_hdr_RowInterface {
guid: fromDatatype.GuidDataFieldInterface;
namespace: fromDatatype.VarcharDatatypeInterface;
applet_guid: fromDatatype.GuidDataFieldInterface;
module_guid: fromDatatype.GuidDataFieldInterface;
template_message_hdr_guid: fromDatatype.GuidDataFieldInterface;
placeholder_name: fromDatatype.VarcharDatatypeInterface;
placeholder_code: fromDatatype.VarcharDatatypeInterface;
placeholder_type: fromDatatype.VarcharDatatypeInterface;
placeholder_source: fromDatatype.VarcharDatatypeInterface;
default_value: fromDatatype.VarcharDatatypeInterface;
template_message_line_guid: fromDatatype.GuidDataFieldInterface;
placeholder_data_type: fromDatatype.VarcharDatatypeInterface;
value_string: fromDatatype.VarcharDatatypeInterface;
value_file: fromDatatype.VarcharDatatypeInterface;
value_numeric: fromDatatype.NumericDatatypeInterface;
value_datetime: fromDatatype.TimestampTzDatatypeInterface;
value_json: fromDatatype.JsonDatatypeInterface;
index: fromDatatype.IntegerDatatypeInterface;
description: fromDatatype.TextDatatypeInterface;
acl_config: fromDatatype.JsonDatatypeInterface;
acl_policy: fromDatatype.JsonDatatypeInterface;
property_json: fromDatatype.JsonDatatypeInterface;
created_date: fromDatatype.TimestampTzDatatypeInterface;
updated_date: fromDatatype.TimestampTzDatatypeInterface;
created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
status: fromDatatype.VarcharDatatypeInterface;
revision: fromDatatype.GuidDataFieldInterface;
vrsn: fromDatatype.VarcharDatatypeInterface;
}
